/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ChannelConfirmRequest,
    ChannelConfirmRequestFromJSON,
    ChannelConfirmRequestToJSON,
} from '../models/ChannelConfirmRequest';
import {
    type EmissionNotificationSettings,
    EmissionNotificationSettingsFromJSON,
    EmissionNotificationSettingsToJSON,
} from '../models/EmissionNotificationSettings';
import {
    type EmissionNotificationSettingsRequest,
    EmissionNotificationSettingsRequestFromJSON,
    EmissionNotificationSettingsRequestToJSON,
} from '../models/EmissionNotificationSettingsRequest';
import {
    type NotificationChannel,
    NotificationChannelFromJSON,
    NotificationChannelToJSON,
} from '../models/NotificationChannel';
import {
    type NotificationChannelRequest,
    NotificationChannelRequestFromJSON,
    NotificationChannelRequestToJSON,
} from '../models/NotificationChannelRequest';
import {
    type NotificationGroup,
    NotificationGroupFromJSON,
    NotificationGroupToJSON,
} from '../models/NotificationGroup';
import {
    type NotificationGroupCreate,
    NotificationGroupCreateFromJSON,
    NotificationGroupCreateToJSON,
} from '../models/NotificationGroupCreate';
import {
    type NotificationGroupCreateRequest,
    NotificationGroupCreateRequestFromJSON,
    NotificationGroupCreateRequestToJSON,
} from '../models/NotificationGroupCreateRequest';
import {
    type PaginatedEmissionNotificationSettingsList,
    PaginatedEmissionNotificationSettingsListFromJSON,
    PaginatedEmissionNotificationSettingsListToJSON,
} from '../models/PaginatedEmissionNotificationSettingsList';
import {
    type PaginatedNotificationChannelList,
    PaginatedNotificationChannelListFromJSON,
    PaginatedNotificationChannelListToJSON,
} from '../models/PaginatedNotificationChannelList';
import {
    type PaginatedNotificationGroupList,
    PaginatedNotificationGroupListFromJSON,
    PaginatedNotificationGroupListToJSON,
} from '../models/PaginatedNotificationGroupList';
import {
    type PatchedEmissionNotificationSettingsRequest,
    PatchedEmissionNotificationSettingsRequestFromJSON,
    PatchedEmissionNotificationSettingsRequestToJSON,
} from '../models/PatchedEmissionNotificationSettingsRequest';
import {
    type PatchedNotificationChannelRequest,
    PatchedNotificationChannelRequestFromJSON,
    PatchedNotificationChannelRequestToJSON,
} from '../models/PatchedNotificationChannelRequest';
import {
    type PatchedNotificationGroupCreateRequest,
    PatchedNotificationGroupCreateRequestFromJSON,
    PatchedNotificationGroupCreateRequestToJSON,
} from '../models/PatchedNotificationGroupCreateRequest';

export interface NotificationsChannelsConfirmEmailCreateRequest {
    channelConfirmRequest: ChannelConfirmRequest;
}

export interface NotificationsChannelsCreateRequest {
    notificationChannelRequest: NotificationChannelRequest;
}

export interface NotificationsChannelsDestroyRequest {
    id: number;
}

export interface NotificationsChannelsListRequest {
    ordering?: string;
    owner?: number;
    page?: number;
    pageSize?: number;
}

export interface NotificationsChannelsPartialUpdateRequest {
    id: number;
    patchedNotificationChannelRequest?: PatchedNotificationChannelRequest;
}

export interface NotificationsChannelsResendEmailConfirmationCreateRequest {
    id: number;
}

export interface NotificationsChannelsRetrieveRequest {
    id: number;
}

export interface NotificationsChannelsUpdateRequest {
    id: number;
    notificationChannelRequest: NotificationChannelRequest;
}

export interface NotificationsEmissionsCreateRequest {
    emissionNotificationSettingsRequest?: EmissionNotificationSettingsRequest;
}

export interface NotificationsEmissionsDestroyRequest {
    id: number;
}

export interface NotificationsEmissionsListRequest {
    ordering?: string;
    owner?: number;
    page?: number;
    pageSize?: number;
}

export interface NotificationsEmissionsPartialUpdateRequest {
    id: number;
    patchedEmissionNotificationSettingsRequest?: PatchedEmissionNotificationSettingsRequest;
}

export interface NotificationsEmissionsRetrieveRequest {
    id: number;
}

export interface NotificationsEmissionsUpdateRequest {
    id: number;
    emissionNotificationSettingsRequest?: EmissionNotificationSettingsRequest;
}

export interface NotificationsGroupsCreateRequest {
    notificationGroupCreateRequest: NotificationGroupCreateRequest;
}

export interface NotificationsGroupsDestroyRequest {
    id: number;
}

export interface NotificationsGroupsListRequest {
    ordering?: string;
    owner?: number;
    page?: number;
    pageSize?: number;
}

export interface NotificationsGroupsPartialUpdateRequest {
    id: number;
    patchedNotificationGroupCreateRequest?: PatchedNotificationGroupCreateRequest;
}

export interface NotificationsGroupsRetrieveRequest {
    id: number;
}

export interface NotificationsGroupsUpdateRequest {
    id: number;
    notificationGroupCreateRequest: NotificationGroupCreateRequest;
}

/**
 * 
 */
export class NotificationsApi extends runtime.BaseAPI {

    /**
     * Creates request options for notificationsChannelsConfirmEmailCreate without sending the request
     */
    async notificationsChannelsConfirmEmailCreateRequestOpts(requestParameters: NotificationsChannelsConfirmEmailCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['channelConfirmRequest'] == null) {
            throw new runtime.RequiredError(
                'channelConfirmRequest',
                'Required parameter "channelConfirmRequest" was null or undefined when calling notificationsChannelsConfirmEmailCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/notifications/channels/confirm_email/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChannelConfirmRequestToJSON(requestParameters['channelConfirmRequest']),
        };
    }

    /**
     * Confirm email channel.  This is a public endpoint.
     */
    async notificationsChannelsConfirmEmailCreateRaw(requestParameters: NotificationsChannelsConfirmEmailCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.notificationsChannelsConfirmEmailCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Confirm email channel.  This is a public endpoint.
     */
    async notificationsChannelsConfirmEmailCreate(requestParameters: NotificationsChannelsConfirmEmailCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.notificationsChannelsConfirmEmailCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for notificationsChannelsCreate without sending the request
     */
    async notificationsChannelsCreateRequestOpts(requestParameters: NotificationsChannelsCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['notificationChannelRequest'] == null) {
            throw new runtime.RequiredError(
                'notificationChannelRequest',
                'Required parameter "notificationChannelRequest" was null or undefined when calling notificationsChannelsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/notifications/channels/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NotificationChannelRequestToJSON(requestParameters['notificationChannelRequest']),
        };
    }

    /**
     * A viewset to retrieve and edit notification channels.
     */
    async notificationsChannelsCreateRaw(requestParameters: NotificationsChannelsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationChannel>> {
        const requestOptions = await this.notificationsChannelsCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationChannelFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve and edit notification channels.
     */
    async notificationsChannelsCreate(requestParameters: NotificationsChannelsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationChannel> {
        const response = await this.notificationsChannelsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for notificationsChannelsDestroy without sending the request
     */
    async notificationsChannelsDestroyRequestOpts(requestParameters: NotificationsChannelsDestroyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling notificationsChannelsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/notifications/channels/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve and edit notification channels.
     */
    async notificationsChannelsDestroyRaw(requestParameters: NotificationsChannelsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.notificationsChannelsDestroyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * A viewset to retrieve and edit notification channels.
     */
    async notificationsChannelsDestroy(requestParameters: NotificationsChannelsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.notificationsChannelsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for notificationsChannelsList without sending the request
     */
    async notificationsChannelsListRequestOpts(requestParameters: NotificationsChannelsListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['owner'] != null) {
            queryParameters['owner'] = requestParameters['owner'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/notifications/channels/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve and edit notification channels.
     */
    async notificationsChannelsListRaw(requestParameters: NotificationsChannelsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedNotificationChannelList>> {
        const requestOptions = await this.notificationsChannelsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedNotificationChannelListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve and edit notification channels.
     */
    async notificationsChannelsList(requestParameters: NotificationsChannelsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedNotificationChannelList> {
        const response = await this.notificationsChannelsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for notificationsChannelsPartialUpdate without sending the request
     */
    async notificationsChannelsPartialUpdateRequestOpts(requestParameters: NotificationsChannelsPartialUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling notificationsChannelsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/notifications/channels/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedNotificationChannelRequestToJSON(requestParameters['patchedNotificationChannelRequest']),
        };
    }

    /**
     * A viewset to retrieve and edit notification channels.
     */
    async notificationsChannelsPartialUpdateRaw(requestParameters: NotificationsChannelsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationChannel>> {
        const requestOptions = await this.notificationsChannelsPartialUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationChannelFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve and edit notification channels.
     */
    async notificationsChannelsPartialUpdate(requestParameters: NotificationsChannelsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationChannel> {
        const response = await this.notificationsChannelsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for notificationsChannelsResendEmailConfirmationCreate without sending the request
     */
    async notificationsChannelsResendEmailConfirmationCreateRequestOpts(requestParameters: NotificationsChannelsResendEmailConfirmationCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling notificationsChannelsResendEmailConfirmationCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/notifications/channels/{id}/resend_email_confirmation/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Resend the email confirmation.
     */
    async notificationsChannelsResendEmailConfirmationCreateRaw(requestParameters: NotificationsChannelsResendEmailConfirmationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.notificationsChannelsResendEmailConfirmationCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Resend the email confirmation.
     */
    async notificationsChannelsResendEmailConfirmationCreate(requestParameters: NotificationsChannelsResendEmailConfirmationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.notificationsChannelsResendEmailConfirmationCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for notificationsChannelsRetrieve without sending the request
     */
    async notificationsChannelsRetrieveRequestOpts(requestParameters: NotificationsChannelsRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling notificationsChannelsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/notifications/channels/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve and edit notification channels.
     */
    async notificationsChannelsRetrieveRaw(requestParameters: NotificationsChannelsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationChannel>> {
        const requestOptions = await this.notificationsChannelsRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationChannelFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve and edit notification channels.
     */
    async notificationsChannelsRetrieve(requestParameters: NotificationsChannelsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationChannel> {
        const response = await this.notificationsChannelsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for notificationsChannelsUpdate without sending the request
     */
    async notificationsChannelsUpdateRequestOpts(requestParameters: NotificationsChannelsUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling notificationsChannelsUpdate().'
            );
        }

        if (requestParameters['notificationChannelRequest'] == null) {
            throw new runtime.RequiredError(
                'notificationChannelRequest',
                'Required parameter "notificationChannelRequest" was null or undefined when calling notificationsChannelsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/notifications/channels/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: NotificationChannelRequestToJSON(requestParameters['notificationChannelRequest']),
        };
    }

    /**
     * A viewset to retrieve and edit notification channels.
     */
    async notificationsChannelsUpdateRaw(requestParameters: NotificationsChannelsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationChannel>> {
        const requestOptions = await this.notificationsChannelsUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationChannelFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve and edit notification channels.
     */
    async notificationsChannelsUpdate(requestParameters: NotificationsChannelsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationChannel> {
        const response = await this.notificationsChannelsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for notificationsEmissionsCreate without sending the request
     */
    async notificationsEmissionsCreateRequestOpts(requestParameters: NotificationsEmissionsCreateRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/notifications/emissions/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmissionNotificationSettingsRequestToJSON(requestParameters['emissionNotificationSettingsRequest']),
        };
    }

    /**
     * A viewset to retrieve and edit emission notification settings
     */
    async notificationsEmissionsCreateRaw(requestParameters: NotificationsEmissionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmissionNotificationSettings>> {
        const requestOptions = await this.notificationsEmissionsCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmissionNotificationSettingsFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve and edit emission notification settings
     */
    async notificationsEmissionsCreate(requestParameters: NotificationsEmissionsCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmissionNotificationSettings> {
        const response = await this.notificationsEmissionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for notificationsEmissionsDestroy without sending the request
     */
    async notificationsEmissionsDestroyRequestOpts(requestParameters: NotificationsEmissionsDestroyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling notificationsEmissionsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/notifications/emissions/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve and edit emission notification settings
     */
    async notificationsEmissionsDestroyRaw(requestParameters: NotificationsEmissionsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.notificationsEmissionsDestroyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * A viewset to retrieve and edit emission notification settings
     */
    async notificationsEmissionsDestroy(requestParameters: NotificationsEmissionsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.notificationsEmissionsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for notificationsEmissionsList without sending the request
     */
    async notificationsEmissionsListRequestOpts(requestParameters: NotificationsEmissionsListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['owner'] != null) {
            queryParameters['owner'] = requestParameters['owner'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/notifications/emissions/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve and edit emission notification settings
     */
    async notificationsEmissionsListRaw(requestParameters: NotificationsEmissionsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedEmissionNotificationSettingsList>> {
        const requestOptions = await this.notificationsEmissionsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedEmissionNotificationSettingsListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve and edit emission notification settings
     */
    async notificationsEmissionsList(requestParameters: NotificationsEmissionsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedEmissionNotificationSettingsList> {
        const response = await this.notificationsEmissionsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for notificationsEmissionsPartialUpdate without sending the request
     */
    async notificationsEmissionsPartialUpdateRequestOpts(requestParameters: NotificationsEmissionsPartialUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling notificationsEmissionsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/notifications/emissions/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedEmissionNotificationSettingsRequestToJSON(requestParameters['patchedEmissionNotificationSettingsRequest']),
        };
    }

    /**
     * A viewset to retrieve and edit emission notification settings
     */
    async notificationsEmissionsPartialUpdateRaw(requestParameters: NotificationsEmissionsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmissionNotificationSettings>> {
        const requestOptions = await this.notificationsEmissionsPartialUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmissionNotificationSettingsFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve and edit emission notification settings
     */
    async notificationsEmissionsPartialUpdate(requestParameters: NotificationsEmissionsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmissionNotificationSettings> {
        const response = await this.notificationsEmissionsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for notificationsEmissionsRetrieve without sending the request
     */
    async notificationsEmissionsRetrieveRequestOpts(requestParameters: NotificationsEmissionsRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling notificationsEmissionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/notifications/emissions/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve and edit emission notification settings
     */
    async notificationsEmissionsRetrieveRaw(requestParameters: NotificationsEmissionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmissionNotificationSettings>> {
        const requestOptions = await this.notificationsEmissionsRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmissionNotificationSettingsFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve and edit emission notification settings
     */
    async notificationsEmissionsRetrieve(requestParameters: NotificationsEmissionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmissionNotificationSettings> {
        const response = await this.notificationsEmissionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for notificationsEmissionsUpdate without sending the request
     */
    async notificationsEmissionsUpdateRequestOpts(requestParameters: NotificationsEmissionsUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling notificationsEmissionsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/notifications/emissions/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EmissionNotificationSettingsRequestToJSON(requestParameters['emissionNotificationSettingsRequest']),
        };
    }

    /**
     * A viewset to retrieve and edit emission notification settings
     */
    async notificationsEmissionsUpdateRaw(requestParameters: NotificationsEmissionsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmissionNotificationSettings>> {
        const requestOptions = await this.notificationsEmissionsUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmissionNotificationSettingsFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve and edit emission notification settings
     */
    async notificationsEmissionsUpdate(requestParameters: NotificationsEmissionsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmissionNotificationSettings> {
        const response = await this.notificationsEmissionsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for notificationsGroupsCreate without sending the request
     */
    async notificationsGroupsCreateRequestOpts(requestParameters: NotificationsGroupsCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['notificationGroupCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'notificationGroupCreateRequest',
                'Required parameter "notificationGroupCreateRequest" was null or undefined when calling notificationsGroupsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/notifications/groups/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NotificationGroupCreateRequestToJSON(requestParameters['notificationGroupCreateRequest']),
        };
    }

    /**
     * A viewset to retrieve and edit notification group.
     */
    async notificationsGroupsCreateRaw(requestParameters: NotificationsGroupsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationGroupCreate>> {
        const requestOptions = await this.notificationsGroupsCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationGroupCreateFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve and edit notification group.
     */
    async notificationsGroupsCreate(requestParameters: NotificationsGroupsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationGroupCreate> {
        const response = await this.notificationsGroupsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for notificationsGroupsDestroy without sending the request
     */
    async notificationsGroupsDestroyRequestOpts(requestParameters: NotificationsGroupsDestroyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling notificationsGroupsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/notifications/groups/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve and edit notification group.
     */
    async notificationsGroupsDestroyRaw(requestParameters: NotificationsGroupsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.notificationsGroupsDestroyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * A viewset to retrieve and edit notification group.
     */
    async notificationsGroupsDestroy(requestParameters: NotificationsGroupsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.notificationsGroupsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for notificationsGroupsList without sending the request
     */
    async notificationsGroupsListRequestOpts(requestParameters: NotificationsGroupsListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['owner'] != null) {
            queryParameters['owner'] = requestParameters['owner'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/notifications/groups/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve and edit notification group.
     */
    async notificationsGroupsListRaw(requestParameters: NotificationsGroupsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedNotificationGroupList>> {
        const requestOptions = await this.notificationsGroupsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedNotificationGroupListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve and edit notification group.
     */
    async notificationsGroupsList(requestParameters: NotificationsGroupsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedNotificationGroupList> {
        const response = await this.notificationsGroupsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for notificationsGroupsPartialUpdate without sending the request
     */
    async notificationsGroupsPartialUpdateRequestOpts(requestParameters: NotificationsGroupsPartialUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling notificationsGroupsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/notifications/groups/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedNotificationGroupCreateRequestToJSON(requestParameters['patchedNotificationGroupCreateRequest']),
        };
    }

    /**
     * A viewset to retrieve and edit notification group.
     */
    async notificationsGroupsPartialUpdateRaw(requestParameters: NotificationsGroupsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationGroupCreate>> {
        const requestOptions = await this.notificationsGroupsPartialUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationGroupCreateFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve and edit notification group.
     */
    async notificationsGroupsPartialUpdate(requestParameters: NotificationsGroupsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationGroupCreate> {
        const response = await this.notificationsGroupsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for notificationsGroupsRetrieve without sending the request
     */
    async notificationsGroupsRetrieveRequestOpts(requestParameters: NotificationsGroupsRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling notificationsGroupsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/notifications/groups/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve and edit notification group.
     */
    async notificationsGroupsRetrieveRaw(requestParameters: NotificationsGroupsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationGroup>> {
        const requestOptions = await this.notificationsGroupsRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationGroupFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve and edit notification group.
     */
    async notificationsGroupsRetrieve(requestParameters: NotificationsGroupsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationGroup> {
        const response = await this.notificationsGroupsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for notificationsGroupsUpdate without sending the request
     */
    async notificationsGroupsUpdateRequestOpts(requestParameters: NotificationsGroupsUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling notificationsGroupsUpdate().'
            );
        }

        if (requestParameters['notificationGroupCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'notificationGroupCreateRequest',
                'Required parameter "notificationGroupCreateRequest" was null or undefined when calling notificationsGroupsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/notifications/groups/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: NotificationGroupCreateRequestToJSON(requestParameters['notificationGroupCreateRequest']),
        };
    }

    /**
     * A viewset to retrieve and edit notification group.
     */
    async notificationsGroupsUpdateRaw(requestParameters: NotificationsGroupsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationGroupCreate>> {
        const requestOptions = await this.notificationsGroupsUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationGroupCreateFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve and edit notification group.
     */
    async notificationsGroupsUpdate(requestParameters: NotificationsGroupsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationGroupCreate> {
        const response = await this.notificationsGroupsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
